const e="undefined"!=typeof localStorage,o="J151000",t="J151001";export{t as FETCH_ERROR_RESPONSE_ERROR_CODE,o as FETCH_EXCEPTION_ERROR_CODE,e as IS_LOCAL_STORAGE};
//# sourceMappingURL=general.js.map
